import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { theme } from '../../../config/theme.ts';

interface CardHeaderTitleProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  center?: boolean;
}

const StyledStack = styled(Stack)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

const IconBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.primary.light,
  height: '30px',
}));

const CardHeaderTitle: React.FC<CardHeaderTitleProps> = ({
  title,
  subtitle,
  icon,
  center = false,
}) => {
  return (
    <StyledStack
      sx={{
        alignItems: center ? 'center' : 'flex-start',
        textAlign: center ? 'center' : 'left',
      }}
    >
      <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
        {icon && <IconBox>{icon}</IconBox>}
        {title &&
          (typeof title === 'string' ? (
            <Typography variant="h5" color={theme.palette.primary.main}>
              {title}
            </Typography>
          ) : (
            title
          ))}
      </Stack>
      {subtitle && (
        <Typography variant="body2" color={theme.palette.text.secondary}>
          {subtitle}
        </Typography>
      )}
    </StyledStack>
  );
};

export default CardHeaderTitle;
